type LockIconProps = {
  className?: string;
};
const LockIcon = ({ className }: LockIconProps) => {
  return (
    <svg
      width="29"
      height="33"
      viewBox="0 0 29 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.5 20.4167V23.75M6.0625 12.9647C6.85802 12.9167 7.83875 12.9167 9.1 12.9167H19.9C21.1612 12.9167 22.142 12.9167 22.9375 12.9647M6.0625 12.9647C5.06971 13.0245 4.36536 13.1592 3.76418 13.4617C2.8116 13.941 2.03714 14.7058 1.55178 15.6467C1 16.7163 1 18.1163 1 20.9167V23.25C1 26.0503 1 27.4503 1.55178 28.52C2.03714 29.4608 2.8116 30.2257 3.76418 30.705C4.8471 31.25 6.26473 31.25 9.1 31.25H19.9C22.7353 31.25 24.1528 31.25 25.2359 30.705C26.1885 30.2257 26.9629 29.4608 27.4482 28.52C28 27.4503 28 26.0503 28 23.25V20.9167C28 18.1163 28 16.7163 27.4482 15.6467C26.9629 14.7058 26.1885 13.941 25.2359 13.4617C24.6346 13.1592 23.9303 13.0245 22.9375 12.9647M6.0625 12.9647V9.58333C6.0625 4.98097 9.8401 1.25 14.5 1.25C19.1599 1.25 22.9375 4.98097 22.9375 9.58333V12.9647"
        stroke="#51FF71"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LockIcon;
